// extracted by mini-css-extract-plugin
module.exports = {"root":"input-checkbox_root__xL9dx","input":"input-checkbox_input__9gmFJ","label":"input-checkbox_label__2D6Yy","blink":"input-checkbox_blink__3EBkm"};